import angular from 'angular'
import taxablePage from './view/taxable.html'

class taxableCtrl {
    constructor(httpRequest, sweetalert) {
        const scope = this
        scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                ysxmDmAndYsxmmc: '',
                accessToken: localStorage.getItem('id_token'),
            },
        }
        scope.reset = function () {
            scope.queryParam.param = {
                ysxmDmAndYsxmmc: '',
                accessToken: localStorage.getItem('id_token'),
            }
        }
        // scope.reset()
        scope.queryList = function queryList() {
            httpRequest.post_getSbYgzsdYsxmmxbList(scope.queryParam).then((res) => {
                scope.listData = res.data.value.list
                scope.totalItems = res.data.value.total
                scope.queryParam.pageNum = res.data.value.pageNum
            })
        }
        scope.queryList()
        scope.importconfig = {
            code: 'ZZSYSXM',
            validate: {
                pattern: '.xlsx,.xls',
                _validate: {
                    size: { min: 10, max: '10MB' },
                    duration: { min: '10s', max: '5m' },
                    accept: '.xlsx,.xls',
                },
            },
            appName: host.etcloudSb,
            hideDownload: true,
            callback() {
                scope.queryList()
            },
        }
        scope.upload = function upload() {
            const msg = '导入后将全面覆盖已有的营改增试点应税项目明细表，确定要导入吗？'
            sweetalert.confirm('确认上传', msg).then(() => {
                angular.element('#taxable-upload .j-importexcel').click()
            }, () => { })
        }
        // 表头排序
        scope.orderMap = { sortKey: '', sortVal: '' }
        scope.selectedHandle = function selectedHandle() {
            scope.queryParam.orderMap = {}
            if (scope.orderMap.sortKey) scope.queryParam.orderMap[scope.orderMap.sortKey] = scope.orderMap.sortVal
            scope.queryList()
        }
        // 导出
        scope.exportTaxClass = function exportTaxClass() {
            httpRequest.get_exportSbYgzsdYsxmmxbToExcel(scope.queryParam.param)
        }
    }
}
taxableCtrl.$inject = ['httpRequest', 'sweetalert']
export default angular.module('system.basedata.taxPolicy.taxable', [])
    .controller('taxableCtrl', taxableCtrl)
    .component('taxable', {
        template: taxablePage,
        controller: 'taxableCtrl',
    }).name



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxClass/taxableListComponent.js